/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feSunset', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherSunsetIconData */

/** @type {FeatherSunsetIconData} */
const feSunset = {
  prefix: 'fe',
  iconName: 'sunset',
  icon: [
    24,
    24,
    '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sunset"><path d="M17 18a5 5 0 0 0-10 0"/><path d="M12 9 L12 2"/><path d="M4.22 10.22 L5.64 11.64"/><path d="M1 18 L3 18"/><path d="M21 18 L23 18"/><path d="M18.36 11.64 L19.78 10.22"/><path d="M23 22 L1 22"/><path d="M16 5 L12 9 L8 5"/></svg>',
    'M17 18a5 5 0 0 0-10 0 M12 9 L12 2 M4.22 10.22 L5.64 11.64 M1 18 L3 18 M21 18 L23 18 M18.36 11.64 L19.78 10.22 M23 22 L1 22 M16 5 L12 9 L8 5',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feSunset
